{{ title }}
<div class="d3-chart" #grid style="border: lightslategrey;"></div>